import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActionSheetController, IonicSlides, ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { OnboardingSlide } from 'src/app/interfaces/interfaces';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { LanguageService } from 'src/app/services/languageservice/language.service';
import { Capacitor } from '@capacitor/core';
import { Subscription } from 'rxjs';
import Lottie, { AnimationItem } from 'lottie-web';


@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent  implements OnInit {
  swiperModules = [IonicSlides];
  @ViewChild('swiper') swiperRef: ElementRef | undefined;
  @ViewChildren('animationContainer') animationContainers!: QueryList<ElementRef<HTMLElement>>;
  swiper?: Swiper
  activeSlide = 0
  slide1: OnboardingSlide = {image: 'assets/onboarding/HXA_SmartOffice.jpg',header:'onboarding.slider1.header',discription:['onboarding.slider1.discription1']}
  slide2: OnboardingSlide = {image: 'assets/onboarding/Microsoft.png',header:'onboarding.slider2.header',discription:['onboarding.slider2.discription1']}
  slide3: OnboardingSlide = {image: 'assets/onboarding/Filter.json',deImage: 'assets/onboarding/De-filter.json',isAnimation: true,header:'onboarding.slider3.header',discription:['onboarding.slider3.discription1']}
  slide4: OnboardingSlide = {image: 'assets/onboarding/Resources.json',deImage: 'assets/onboarding/De-Resources.json',isAnimation: true,header:'onboarding.slider4.header',discription:['onboarding.slider4.discription1']}
  slide5: OnboardingSlide = {image: 'assets/onboarding/Assistant.json',deImage: 'assets/onboarding/De-Assistant.json',isAnimation: true,header:'onboarding.slider5.header',discription:['onboarding.slider5.discription1']}
  slide6: OnboardingSlide = {image: 'assets/onboarding/Dashboard.json',deImage: 'assets/onboarding/De-Dashboard.json',isAnimation: true,header:'onboarding.slider6.header',discription:['onboarding.slider6.discription1','onboarding.slider6.discription2']}
  slide7: OnboardingSlide = {image: 'assets/onboarding/floor plan.json',deImage: 'assets/onboarding/De-floor plan.json',isAnimation: true,header:'onboarding.slider7.header',discription:['onboarding.slider7.discription1']}

  slides: Array<OnboardingSlide> = [this.slide1, this.slide2,this.slide3,this.slide4,this.slide5,this.slide6,this.slide7];
  private readonly defaultSlideImages = this.slides.map((slide) => slide.image);
  private readonly animationReplayDelayMs = 10000;
  private readonly animationInstances: AnimationItem[] = [];
  private readonly animationReplayTimeouts = new Set<ReturnType<typeof setTimeout>>();
  private readonly animationCompleteListeners: Array<() => void> = [];
  private languageSubscription?: Subscription;

  constructor( private modalController: ModalController,private actionSheetController:ActionSheetController,private translateService : TranslateService, public languageService: LanguageService,  private platform: Platform) { }



  ngOnInit() {
    this.languageSubscription = this.languageService.selectedLanguage$.subscribe((language) => {
      this.applySlideLanguage(language?.value === 'de');
      this.initializeAnimations();
    });
  }
 
  ngAfterViewInit(){
    if (this.swiperRef) {
    const swiperEl = this.swiperRef.nativeElement;
    swiperEl.initialize();
    this.swiper = swiperEl.swiper;  
    }

    this.animationContainers.changes.subscribe(() => {
      this.initializeAnimations();
    });

    this.initializeAnimations();
  }

  ngOnDestroy() {
    this.languageSubscription?.unsubscribe();
    this.destroyAnimations();
  }
  compare(e1: any, e2: any): boolean {
    
    return e1 && e2 ? e1.value == e2.value : e1 == e2;
  }

  // changeLanguage(event) {
    
  //   this.languageService.selectLanguage(event.target.value)
  //   if(!this.platform.is('capacitor')){
  //   localStorage.setItem("selectedlanguage",JSON.stringify( event.target.value))
  //   } 
  // }

  public dismissModal() {
    this.modalController.dismiss()
  }

  closeOnboarding() {
    this.presentCloseOptions(true)
  }
  
  public goNext(){
    if(this.swiper.activeIndex == this.slides.length - 1) {
     return this.dismissModal();
    }
    this.swiper.slideNext();
  }

  public goPrevious(){
    this.swiper.slidePrev();
  }

  public onSlideChange() {
    this.activeSlide = this.swiper.activeIndex
    this.initializeAnimations();
  }
 

  async presentCloseOptions(triggeredFromCloseButton = false) {
    let closeOnboardingButtons = [
      {
        text: this.translateService.instant('onboarding.dontShowOnboardingAgain'), 
        role: 'destructive',
      },
      {
        text: this.translateService.instant('onboarding.closeOnboarding'),
        handler: ()=> {
          this.modalController.dismiss('close')
        }
      },
      {
        text: this.translateService.instant('cancelButton'),
        role: 'cancel',
      },
    ]

    let finishOnboardingButtons = [
      {
        text: this.translateService.instant('onboarding.dontShowOnboardingAgain'),
        role: 'destructive',
      },
      {
        text: this.translateService.instant('Just finish turtorial'),
        handler: ()=> {
          this.modalController.dismiss('close')
        }
      },
      {
        text: this.translateService.instant('cancelButton'),
        role: 'cancel',
      },
    ]
    const actionSheet = await this.actionSheetController.create({
      mode: 'ios',
      buttons: triggeredFromCloseButton ? closeOnboardingButtons : finishOnboardingButtons,
    });
    await actionSheet.present();
    const result = await actionSheet.onDidDismiss();
    if (result.role === 'destructive') {
      localStorage.setItem("hideOnboarding",'true')
      this.modalController.dismiss('close')
    }
   

  }

  private applySlideLanguage(isGerman: boolean) {
    this.slides.forEach((slide, index) => {
      if (!slide.deImage) {
        return;
      }

      slide.image = isGerman ? slide.deImage : this.defaultSlideImages[index];
    });
  }

  private initializeAnimations() {
    if (!this.animationContainers) {
      return;
    }

    this.destroyAnimations();

    this.animationContainers.forEach((containerRef) => {
      const container = containerRef.nativeElement;
      const slideIndex = Number(container.dataset['slideIndex']);
      const slide = this.slides[slideIndex];

      if (!slide || !slide.isAnimation) {
        return;
      }

      const animation = Lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: slide.image,
      });

      const removeCompleteListener = animation.addEventListener('complete', () => {
        const replayTimeout = setTimeout(() => {
          this.animationReplayTimeouts.delete(replayTimeout);
          animation.goToAndPlay(0, true);
        }, this.animationReplayDelayMs);

        this.animationReplayTimeouts.add(replayTimeout);
      });

      this.animationCompleteListeners.push(removeCompleteListener);
      this.animationInstances.push(animation);
    });
  }

  private destroyAnimations() {
    this.animationReplayTimeouts.forEach((replayTimeout) => clearTimeout(replayTimeout));
    this.animationReplayTimeouts.clear();

    this.animationCompleteListeners.forEach((removeCompleteListener) => removeCompleteListener());
    this.animationCompleteListeners.length = 0;

    this.animationInstances.forEach((animation) => animation.destroy());
    this.animationInstances.length = 0;
  }
}
